/*
 * From http://www.redblobgames.com/x/1744-rendering-game-elements/
 * Copyright 2017 Red Blob Games <redblobgames@gmail.com>
 * License: Apache v2.0 <http://www.apache.org/licenses/LICENSE-2.0.html>
 */
'use strict';

function mix(a, b, t) {
    return a * (1-t) + b * t;
}

exports.regions = function(ctx, map) {
    let {mesh} = map;
    let out_s = [];

    ctx.strokeStyle = "black";
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = '18px sans-serif';
    for (let r = 0; r < mesh.numSolidRegions; r++) {
        mesh.r_circulate_s(out_s, r);
        let last_t = mesh.s_inner_t(out_s[0]);
        ctx.fillStyle = map.r_water[r]? "#336699" : "#d2b98b";
        ctx.beginPath();
        ctx.moveTo(mesh.t_x(last_t), mesh.t_y(last_t));
        for (let s of out_s) {
            let first_t = mesh.s_outer_t(s);
            ctx.lineTo(mesh.t_x(first_t), mesh.t_y(first_t));
        }
        ctx.fill();
    }
};

exports.sides = function(ctx, map) {
    let {mesh} = map;
    const a = 0.8;
    ctx.fillStyle = "black";
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = '14px sans-serif';
    for (let s = 0; s < mesh.numSolidSides; s++) {
        let r = mesh.s_begin_r(s);
        let t = mesh.s_inner_t(s);
        ctx.fillText(s,
                     mix(mesh.r_x(r), mesh.t_x(t), a),
                     mix(mesh.r_y(r), mesh.t_y(t), a));
    }
};

function drawPath(ctx, mesh, path) {
    ctx.moveTo(mesh.t_x(mesh.s_inner_t(path[0])),
               mesh.t_y(mesh.s_inner_t(path[0])));
    for (let i = path.length-1; i >= 0; i--) {
        let t = mesh.s_inner_t(path[i]);
        ctx.lineTo(mesh.t_x(t), mesh.t_y(t));
    }
    ctx.closePath();
}

exports.path = function(ctx, map, paths, color) {
    let {mesh} = map;
    ctx.save();
    ctx.lineJoin = 'round';
    ctx.strokeStyle = color;

    ctx.beginPath();
    for (let path of paths) {
        drawPath(ctx, mesh, path);
    }
    ctx.fillStyle = "rgba(255,255,255,0.2)";
    ctx.fill();
    ctx.clip();

    for (let w = 30; w >= 1; w *= 0.9) {
        ctx.lineWidth = w;
        ctx.stroke();
    }
    
    ctx.restore();
};
